import { buildCloudWatchTraceUrl } from "../../config/environment";
import React, { useEffect, useState } from "react";
import { useSearchParams, NavLink } from "react-router-dom";
// import { Button } from "@/components/ui/Button";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import labelMappings from "./labels.json";
import { InsightsTimeline, fetchInsightsByPatient } from "../Insights";

const TracePage = ({ }) => {
  const [searchParams] = useSearchParams();
  const [patientId, setPatientId] = useState("");
  const [logs, setLogs] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlPatientId = searchParams.get("patient_id");
    if (urlPatientId) {
      setPatientId(urlPatientId);
      handleButtonClick(urlPatientId);
    }
  }, [searchParams]);

  const handleOpenLink = () => {
    window.open(buildCloudWatchTraceUrl(patientId), "_blank");
  };

  const handleButtonClick = async (patient_id) => {
    setLoading(true);
    try {
      const result = await fetchInsightsByPatient(patient_id);
      if (result.error) {
        throw new Error(result.error);
      }
      setLogs(result.data);
      setErrorMessage("");
      setLoading(false);
    } catch (error) {
      setErrorMessage(error.message);
      setLogs([]);
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col w-full">
      <NavLink to={"/"} className="absolute top-[1rem] left-[2rem] text-ktx-purple text-[20px] hover:text-ktx-navy font-semibold">Back</NavLink>
      <div className="text-3xl text-light-grey tracking-wider mb-4">
        <div className="p-10">
          <div className="p-4 space-y-4">
            <Input
              placeholder="Enter Patient ID"
              value={patientId}
              onChange={(e) => setPatientId(e.target.value)}
              className="w-full p-2 border rounded-md"
            />
            <Button
              onClick={() => handleButtonClick(patientId)}
              variant="outline"
            >
              Search Patient Logs
            </Button>
          </div>

          <div className="p-5">
            {logs && logs.length > 0 && (
              <div>
                <h2 className="text-2xl mb-4">Insights – {patientId}</h2>

                <Button
                  onClick={handleOpenLink}
                  variant="outline"
                  className="px-4 py-2"
                >
                  View AWS CloudWatch Logs
                </Button>

                <div className="mt-10">
                  <InsightsTimeline data={logs} labelMappings={labelMappings} />
                </div>
              </div>
            )}

            {patientId.length > 0 &&
              setLoading == false &&
              logs.length == 0 && (
                <div className="text-sm">No insight events found for {patientId}</div>
              )}

            {errorMessage && (
              <div className="mt-5 bg-red-50 p-4 rounded-md">
                <h4 className="text-lg font-semibold text-red-800">Error:</h4>
                <p className="text-sm text-red-700 mt-2">{errorMessage}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TracePage;
